<template>
  <div
    class="modal fade"
    ref="exampleModal"
    id="approve-modal"
    tabindex="-1"
    aria-labelledby="approveModal"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered modal-sm">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ payload.titleModal }}</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <div class="mb-3">
            <label for="inputDate" class="form-label">{{
              payload.formLabel
            }}</label>
            <Datepicker
              v-model="dateApprove"
              :enable-time-picker="false"
              :auto-apply="true"
              :min-date="payload?.minDate || new Date()"
              :format="(date)=>filters.dateSimple(date)"
              ></Datepicker>
          </div>
        </div>
        <div class="modal-footer">
          <button
            id="modal-approve-dismiss"
            type="button"
            class="btn btn-outline-danger"
            :style="{flex: 1}"
            data-bs-dismiss="modal"
          >
            <strong class="text-uppercase">Cancel</strong>
          </button>
          <button
            type="button"
            class="btn btn-danger"
            :disabled="!dateApprove"
            :style="{flex: 1}"
            @click="onApproveClick()"
          >
            <strong class="text-white">{{ payload.textButton }}</strong>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Datepicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";

export default {
  components: {
    Datepicker,
  },
  props: {
    payload: {
      type: Object,
      default: () => ({
        titleModal: String,
        formLabel: String,
        textButton: String,
        actionPath: String,
        minDate: String,
        body: Object,
      }),
    },
  },
  data() {
    return {
      titleModal: this.payload.titleModal,
      formLabel: this.payload.formLabel,
      textButton: this.payload.textButton,
      actionPath: this.payload.actionPath,
      body: this.payload.body,
      dateApprove: "",
    };
  },
  watch:{
    "payload.body": {
      handler: function (val) {
        this.dateApprove = ""
      },
      deep: true,
    },
  },
  methods: {
    async onApproveClick() {
      let body = this.body;
      body.approve_time = this.dateApprove;
      document.getElementById("modal-approve-dismiss")?.click()
      await this.$store.dispatch(this.actionPath, body);

      this.$swal({
        icon: "success",
        title: "Success approve.",
        showConfirmButton: false,
        timer: 1500,
      }).then(() => {
        this.$router.go();
      });
    },
  },
};
</script>

<style scoped lang="scss">
</style>
